<template>
    <div v-if="needToCheck" class="box g-pt-5 g-pb-0">
        <div v-if="isLoading">
            <g-loader type="block" />
        </div>

        <div v-else-if="!payoutAccount">
            <base-box border background-color="grey">
                <template #content>
                    <g-media-object>
                        <template #left>
                            <g-icon name="exclamation-circle" class="alert-icon" />
                        </template>

                        <g-typography tag="p"> Your payout information is incomplete. </g-typography>

                        <template #right>
                            <g-button size="small" theme="live" @click="$router.push({ name: 'edit.profile' })">
                                Set Up
                            </g-button>
                        </template>
                    </g-media-object>

                    <div class="margin-top">
                        <g-typography tag="p"> Without this information, you won't be able to get paid. </g-typography>
                    </div>
                </template>
            </base-box>
        </div>
    </div>
</template>

<script>
    import PayoutAccountMixin from '../../../../src/mixins/PayoutAccountMixin';
    import { useAuthStore } from '../../../../stores';

    export default {
        name: 'IncompleteAccountNoticeView',

        mixins: [PayoutAccountMixin],

        computed: {
            needToCheck() {
                return this.$root.account_makes_payments && useAuthStore().isLoggedIn && this.$root.needsLogin;
            }
        },

        mounted() {
            if (this.needToCheck) {
                this.loadPayoutAccount();
            }
        }
    };
</script>

<style lang="scss" scoped>
    .margin-top {
        margin-top: $g-spacing-3;
    }

    .alert-icon {
        color: $g-font-color-info;
    }
</style>
